import React from "react";
import Image from "next/image";
import poster from "../../public/neet-pg/neet-pg-poster.webp";
// const features = [
//   {
//     title: "Allotment Tracker",
//     desc: "Dive into official allotment records from different years, states, and counselling rounds. Everything's laid out in one simple dashboard, so you don't have to dig around.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
//       </svg>
//     )
//   },
//   {
//     title: "Closing Rank Explorer",
//     desc: "Look up closing ranks for every round, course, and medical college—across multiple years. You can filter by category, state quota, or counselling type to zero in on what matters to you.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//       </svg>
//     )
//   },
//   {
//     title: "Real-Time Seat Matrix",
//     desc: "See live seat availability for every institute and category in each round. Stay on top of every chance as soon as it opens up.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//       </svg>
//     )
//   },
//   {
//     title: "Fee, Stipend & Bond Insights ",
//     desc: "Compare tuition fees, stipends, bond durations, and penalties by institute, course, and quota. Get all the numbers, side by side, before making a decision.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//       </svg>
//     )
//   },
//   {
//     title: "Allotment Mapping",
//     desc: "Wondering what your chances are? Check out where candidates with ranks close to yours have landed seats in different rounds and states. Find new options you might've missed.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
//       </svg>
//     )
//   },
//   {
//     title: "Rank Scan",
//     desc: "Type in any rank to see exactly where candidates ended up. Instantly get a visual spread across all states and counselling rounds.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
//       </svg>
//     )
//   },
//   {
//     title: "Seat Expansion Insights",
//     desc: "Keep an eye on where seat numbers have gone up this session, across colleges and specializations.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
//       </svg>
//     )
//   },
//   {
//     title: "My Choice List",
//     desc: "Build and save multiple preference lists for different counsellings. Use real-time data and smart filters to sort things just the way you want.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
//       </svg>
//     )
//   },
//   {
//     title: "Institutes Database",
//     desc: "Get verified info on over 1,000 medical colleges—from how many hospital beds they have to their clinical exposure and academic resources.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
//       </svg>
//     )
//   },
//   {
//     title: "Course Finder",
//     desc: "Dig into every MD/MS specialization. See course duration, recognition status, training type, and more.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
//       </svg>
//     )
//   },
//   {
//     title: "College Profiles",
//     desc: "Browse through medical colleges across India. Check out their affiliations, see which colleges they're linked with, and get the stats you need.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
//       </svg>
//     )
//   },
//   {
//     title: "Counselling Guide",
//     desc: "Confused about quotas, timelines, or steps? Find every detail for both All India and State counselling—no need to look anywhere else.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//       </svg>
//     )
//   },
//   {
//     title: "Verified Resources",
//     desc: "Every bit of data comes straight from official government sources, notifications, or verified documents. No guesswork—just facts.",
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
//       </svg>
//     )
//   },
// ];


const counsellingFeatures = [
  {
    title: "College Ranking Branch Wise",
    desc: "View rankings of colleges for each branch and specialization to make informed choices.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 17v-6a2 2 0 012-2h2a2 2 0 012 2v6m4 0v-4a2 2 0 012-2h2a2 2 0 012 2v4" />
      </svg>
    )
  },
  {
    title: "Cutoff Allotment",
    desc: "Check previous years' cutoff ranks and allotment details for every college and branch.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 17l4 4 4-4m-4-5v9" />
      </svg>
    )
  },
  {
    title: "Fee Stipend Bond",
    desc: "Compare tuition fees, stipends, and bond requirements for all institutes and courses.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )
  },
  {
    title: "Fee Seat Matrix",
    desc: "Access real-time seat matrix and fee details for every round and category.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
      </svg>
    )
  },
  {
    title: "Universities Institute",
    desc: "Browse verified information about universities and medical institutes across India.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    )
  },
  {
    title: "College Compare",
    desc: "Compare colleges side by side on ranking, fees, seats, and more.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 4H6a2 2 0 00-2 2v12a2 2 0 002 2h4m4-16h4a2 2 0 012 2v12a2 2 0 01-2 2h-4" />
      </svg>
    )
  },
  {
    title: "College Ranking",
    desc: "Find out the latest rankings for medical colleges nationwide.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    )
  },
  {
    title: "Seat Distribution",
    desc: "See how seats are distributed by quota, category, and round for every college.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <circle cx="12" cy="12" r="10" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2v10l6 6" />
      </svg>
    )
  },
  {
    title: "Merit List",
    desc: "Access official merit lists for all rounds and states.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    )
  },
  {
    title: "Cutoffs",
    desc: "Find cutoffs for every branch, college, and category from previous years.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      </svg>
    )
  },
  {
    title: "Senior Mentor",
    desc: "Get guidance from senior mentors who have successfully navigated NEET PG counselling.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <circle cx="12" cy="8" r="4" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 20v-2a4 4 0 018 0v2" />
      </svg>
    )
  },
  {
    title: "Junior Mentor",
    desc: "Connect with junior mentors for peer support and recent experiences.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <circle cx="12" cy="8" r="4" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 20v-2a4 4 0 018 0v2" />
      </svg>
    )
  },
  {
    title: "Shortlist Counselling Colleges",
    desc: "Shortlist colleges for counselling based on your preferences and eligibility.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    )
  },
  {
    title: "Documentation Verification",
    desc: "Get step-by-step help for document verification during counselling.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <rect x="4" y="4" width="16" height="16" rx="2" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h8M8 14h8" />
      </svg>
    )
  },
  {
    title: "Application Filling",
    desc: "Guidance for filling out your application forms correctly and efficiently.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 20h9" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16.5 3.5a2.121 2.121 0 113 3L7 19l-4 1 1-4 12.5-12.5z" />
      </svg>
    )
  },
  {
    title: "Choice Filling",
    desc: "Get expert tips for filling your choices and maximizing your chances in counselling.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    )
  },
];

export default function Explore() {
  return (
    <>
      <style jsx>{`
        /* Custom scrollbar styles */
        .scrollbar-thin::-webkit-scrollbar {
          height: 8px;
        }
        .scrollbar-thin::-webkit-scrollbar-track {
          background: #f3f4f6;
          border-radius: 10px;
        }
        .scrollbar-thin::-webkit-scrollbar-thumb {
          background: #fdba74;
          border-radius: 10px;
        }
        .scrollbar-thin::-webkit-scrollbar-thumb:hover {
          background: #fb923c;
        }
      `}</style>

      {/* <section className="w-full mx-auto px-4 sm:px-6 lg:px-8 ">
     
      <div className="lg:hidden mb-6 text-center">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-[#140342]">
          Features that bring <span className="text-[#ff9245]">power to you</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
       
        <div className="hidden lg:block col-span-12 lg:col-span-3">
          <div className="relative rounded-2xl overflow-hidden lg:min-h-[550px] bg-[#ff9245] text-white p-6 lg:p-10 flex flex-col justify-start lg:sticky lg:top-4">
            <div className="pt-4 sm:pt-6 relative z-10">
              <h2 className="text-3xl sm:text-3xl lg:text-4xl font-extrabold leading-tight">
                Start,
                <br />
                Your,
                <br />
                Journey
              </h2>
            </div>

            
            <div className="absolute right-[-10px] lg:right-[-55px] bottom-0">
              <div className="w-[350px] h-[400px] lg:w-[420px] lg:h-[490px] overflow-hidden">
                <Image
                  src={poster}
                  alt="neet pg counselling 2026"
                  width={400}
                  height={600}
                  priority
                  className="w-full h-full object-contain object-bottom"
                />
              </div>
            </div>
          </div>
        </div>

       
        <div className="col-span-12 lg:col-span-9">
       
          <div className="overflow-x-auto pb-4 scrollbar-thin">
            <div className="grid grid-rows-5 grid-flow-col gap-4 min-w-max">
              {features.map((f, idx) => (
                <div key={idx} className="w-[280px] sm:w-[500px] flex items-start gap-3 bg-white rounded-lg p-3 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200">
                  <div className="flex-shrink-0 w-9 h-9 rounded-md bg-orange-50 text-orange-600 flex items-center justify-center">
                    {f.icon}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-gray-800">{f.title}</h3>
                    <p className="text-xs text-gray-500 mt-1">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section> */}
      <section className="w-full max-w-6xl mx-auto px-4 ">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-2">
            One solution for smarter decisions in every <span className="text-[#ff9245]">NEET PG round.</span> 
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Stay prepared at every step with reliable guidance and live counselling updates.
          </p>
        </div>
        <div className="mb-10">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Tools</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {[
              "College Ranking Branch Wise",
              "Cutoff Allotment",
              "Fee Stipend Bond",
              "Fee Seat Matrix",
              "Universities Institute",
              "College Compare",
              "College Ranking"
            ].map((name, idx) => {
              const feature = counsellingFeatures.find(f => f.title === name);
              if (!feature) return null;
              return (
                <div key={idx} className="bg-white border border-[#ff9245] rounded-xl p-6 flex flex-col shadow-sm hover:shadow-md transition-shadow items-start">
                  <div className="mb-4 flex items-center justify-center w-9 h-9 rounded-md bg-[#ff9245] text-[#fff]">
                    {feature.icon}
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h4>
                  <p className="text-gray-600 text-sm">{feature.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mb-10">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Analysis</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {[
              "Seat Distribution",
              "Merit List",
              "Cutoffs"
            ].map((name, idx) => {
              const feature = counsellingFeatures.find(f => f.title === name);
              if (!feature) return null;
              return (
                <div key={idx} className="bg-white border border-[#ff9245] rounded-xl p-6 flex flex-col shadow-sm hover:shadow-md transition-shadow items-start">
                  <div className="mb-4 flex items-center justify-center w-9 h-9 rounded-md bg-[#ff9245] text-[#fff]">
                    {feature.icon}
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h4>
                  <p className="text-gray-600 text-sm">{feature.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mb-10">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Post Exam Mentorship</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {[
              "Senior Mentor",
              "Junior Mentor",
              "Shortlist Counselling Colleges",
              "Documentation Verification",
              "Application Filling",
              "Choice Filling"
            ].map((name, idx) => {
              const feature = counsellingFeatures.find(f => f.title === name);
              if (!feature) return null;
              return (
                <div key={idx} className="bg-white border border-[#ff9245] rounded-xl p-6 flex flex-col shadow-sm hover:shadow-md transition-shadow items-start">
                  <div className="mb-4 flex items-center justify-center w-9 h-9 rounded-md bg-[#ff9245] text-[#fff]">
                    {feature.icon}
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h4>
                  <p className="text-gray-600 text-sm">{feature.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex justify-center mt-8">
          <button onClick={() => {window.location.href = '/login'}} className="bg-[#ff9245] hover:bg-[#ff9245] text-white font-semibold py-3 px-6 rounded-full text-lg shadow transition flex items-center gap-2">
            Build your choice list
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
          </button>
        </div>
      </section>
    </>
  );
}
